<template>
    <div>
        <!-- TrustBox widget - Micro TrustScore -->
        <div class="trustpilot-widget tw-mt-4" data-locale="de-DE" data-template-id="5419b637fa0340045cd0c936" data-businessunit-id="6249a28d40123731d8da3c4e" data-style-height="20px" data-style-width="100%">
            <a href="https://de.trustpilot.com/review/wedesigntrips.com" target="_blank" rel="noopener">Trustpilot</a>
        </div>
        <!-- End TrustBox widget -->
        <div
            class="tw-my-8 tw-pt-8 tw-border-t-2 tw-border-red-500"
        >
            <div
                class="tw-text-center tw-mb-4"
            >
                Unsere lokalen Experten werden empfohlen von
            </div>
            <div
                class="tw-space-y-4 tw-justify-center tw-items-center"
            >
                <logo-die-welt/>
                <logo-national-geographic/>
                <LogoLonelyPlanet class="tw-mx-auto"/>
            </div>
        </div>
    </div>
</template>

<script>
import LogoDieWelt from "../icons/LogoDieWelt.vue";
import LogoNationalGeographic from "../icons/LogoNationalGeographic.vue";
import LogoLonelyPlanet from "../icons/LogoLonelyPlanet.vue";

    export default {
        name: "Testimonials",
        components: {
            LogoLonelyPlanet,
            LogoNationalGeographic,
            LogoDieWelt,
        },
        props: {
            icon: {
                type: String,
            },
            coloredIcon: Boolean,
        },
        mounted() {
            this.initTrustpilot();
        },
        methods: {
            initTrustpilot() {
                try {
                    if (window.Trustpilot) {
                        window.Trustpilot.loadFromElement(document.querySelector('.trustpilot-widget'));
                    } else {
                        const isPrivateMode = !window.indexedDB;
                        if (isPrivateMode) {
                            console.log('TrustPilot widget may be blocked by Firefox private browsing mode');
                        }
                    }
                } catch (error) {
                    console.log('Error initializing TrustPilot widget:', error);
                }
            }
        }
    }
</script>

<style scoped>
</style>